import mainStore from './MainStore';

const stores = {
  mainStore
};

export default stores;
